<style>
  :global(.dimmed) { opacity:0.2 }
</style>

<script context="module">
  import Arrow from './Arrow.svelte'
  import Hint from './unobtrusive/Hint.svelte'
  import Separator from './unobtrusive/Separator.svelte'
  import Subtitle from './unobtrusive/Subtitle.svelte'
  import Tag from './unobtrusive/Tag.svelte'
  import Text from './unobtrusive/Text.svelte'
  import TextlineInput from './unobtrusive/TextlineInput.svelte'
  import WebApplication from './unobtrusive/WebApplication.svelte'
</script>

<script>
  let decimal_input = '255'
  let message       = 'enter decimal number'
  let bit_list      = '11111111'.split('').reverse()

  const zero_bit_list = '00000000'.split('').reverse()

  function convert_decimal_input (decimal_input) {
    decimal_input = decimal_input.trim().replace(/^0+([0-9])/,'$1')
    switch (true) {
      case (/^[0-9]+$/.test(decimal_input) == false):
      case (decimal_input === ''):             message = 'enter decimal number (0...255)';      bit_list = zero_bit_list; return
      case (decimal_input.length > 3):         message = 'too many significant decimal digits'; bit_list = zero_bit_list; return
      case (parseInt(decimal_input,10) > 255): message = 'decimal number > 255';                bit_list = zero_bit_list; return
      default:                                 message = 'enter decimal number (0...255)'
    }

    let binary_output = parseInt(decimal_input,10).toString(2)
      binary_output = '00000000'.slice(binary_output.length) + binary_output
    bit_list = binary_output.split('').reverse()
  }

  $: convert_decimal_input(decimal_input)
</script>

<WebApplication style="width:244px; height:280px">
  <Subtitle style="left:12px;top:5px;right:auto;bottom:auto;width:230px;height:30px;">Decimal to Binary Conversion</Subtitle>
  <Separator style="left:6px;top:30px;right:auto;bottom:auto;width:232px;height:10px;"/>
  <Tag style="left:12px;top:35px;right:auto;bottom:auto;width:70px;height:30px;">decimal</Tag>
  <TextlineInput id="DecimalInput" alignment="right" style="left:10px;top:60px;right:auto;bottom:auto;width:60px;height:30px;" bind:value={decimal_input} pattern="^[0-9]*$"/>
  <Tag style="left:122px;top:35px;right:auto;bottom:auto;width:70px;height:30px;">binary</Tag>
  <Tag style="left:83px;top:60px;right:auto;bottom:auto;width:30px;height:30px;">&lt;-&gt;</Tag>
  <Separator style="left:6px;top:256px;right:auto;bottom:auto;width:232px;height:10px;"/>
  <Hint style="left:9px;top:258px;right:auto;bottom:auto;width:230px;height:20px;">{message}</Hint>
  <Text id="bit_7" style="left:122px;top:60px;right:auto;bottom:auto;width:15px;height:30px;">{bit_list[7]}</Text>
  <Text id="bit_6" style="left:132px;top:60px;right:auto;bottom:auto;width:15px;height:30px;">{bit_list[6]}</Text>
  <Text id="bit_5" style="left:142px;top:60px;right:auto;bottom:auto;width:15px;height:30px;">{bit_list[5]}</Text>
  <Text id="bit_4" style="left:152px;top:60px;right:auto;bottom:auto;width:15px;height:30px;">{bit_list[4]}</Text>
  <Text id="bit_3" style="left:162px;top:60px;right:auto;bottom:auto;width:15px;height:30px;">{bit_list[3]}</Text>
  <Text id="bit_2" style="left:172px;top:60px;right:auto;bottom:auto;width:15px;height:30px;">{bit_list[2]}</Text>
  <Text id="bit_1" style="left:182px;top:60px;right:auto;bottom:auto;width:15px;height:30px;">{bit_list[1]}</Text>
  <Text id="bit_0" style="left:192px;top:60px;right:auto;bottom:auto;width:15px;height:30px;">{bit_list[0]}</Text>
  <Text style="left:12px;top:90px;right:auto;bottom:auto;width:15px;height:30px;">=</Text>
  <Text id="bit_value_7" style="left:34px;top:90px;right:auto;bottom:auto;width:40px;height:30px; {bit_list[7] === '0' ? 'opacity:0.2' : ''}">128</Text>
  <Text id="bit_value_6" style="left:22px;top:110px;right:auto;bottom:auto;width:40px;height:30px; {bit_list[6] === '0' ? 'opacity:0.2' : ''}">+ &nbsp; 64</Text>
  <Text id="bit_value_5" style="left:22px;top:130px;right:auto;bottom:auto;width:40px;height:30px; {bit_list[5] === '0' ? 'opacity:0.2' : ''}">+ &nbsp; 32</Text>
  <Text id="bit_value_4" style="left:22px;top:150px;right:auto;bottom:auto;width:40px;height:30px; {bit_list[4] === '0' ? 'opacity:0.2' : ''}">+ &nbsp; 16</Text>
  <Text id="bit_value_3" style="left:22px;top:170px;right:auto;bottom:auto;width:40px;height:30px; {bit_list[3] === '0' ? 'opacity:0.2' : ''}">+ &nbsp; &nbsp; 8</Text>
  <Text id="bit_value_2" style="left:22px;top:190px;right:auto;bottom:auto;width:40px;height:30px; {bit_list[2] === '0' ? 'opacity:0.2' : ''}">+ &nbsp; &nbsp; 4</Text>
  <Text id="bit_value_1" style="left:22px;top:210px;right:auto;bottom:auto;width:40px;height:30px; {bit_list[1] === '0' ? 'opacity:0.2' : ''}">+ &nbsp; &nbsp; 2</Text>
  <Text id="bit_value_0" style="left:22px;top:230px;right:auto;bottom:auto;width:40px;height:30px; {bit_list[0] === '0' ? 'opacity:0.2' : ''}">+ &nbsp; &nbsp; 1</Text>
  <Arrow id="bit_arrow_7" style="left:62px;top:80px;right:auto;bottom:auto;width:70px;height:30px; {bit_list[7] === '0' ? 'opacity:0.2' : ''}"/>
  <Arrow id="bit_arrow_6" style="left:62px;top:80px;right:auto;bottom:auto;width:80px;height:50px; {bit_list[6] === '0' ? 'opacity:0.2' : ''}"/>
  <Arrow id="bit_arrow_5" style="left:62px;top:80px;right:auto;bottom:auto;width:90px;height:70px; {bit_list[5] === '0' ? 'opacity:0.2' : ''}"/>
  <Arrow id="bit_arrow_4" style="left:62px;top:80px;right:auto;bottom:auto;width:100px;height:90px; {bit_list[4] === '0' ? 'opacity:0.2' : ''}"/>
  <Arrow id="bit_arrow_3" style="left:62px;top:80px;right:auto;bottom:auto;width:110px;height:110px; {bit_list[3] === '0' ? 'opacity:0.2' : ''}"/>
  <Arrow id="bit_arrow_2" style="left:62px;top:80px;right:auto;bottom:auto;width:120px;height:130px; {bit_list[2] === '0' ? 'opacity:0.2' : ''}"/>
  <Arrow id="bit_arrow_1" style="left:62px;top:80px;right:auto;bottom:auto;width:130px;height:150px; {bit_list[1] === '0' ? 'opacity:0.2' : ''}"/>
  <Arrow id="bit_arrow_0" style="left:62px;top:80px;right:auto;bottom:auto;width:140px;height:170px; {bit_list[0] === '0' ? 'opacity:0.2' : ''}"/>
</WebApplication>
